"use strict";

define('datadogRum',["jsqObservability"], function (jsqObservability) {
  const datadogRum = {
    init: function (subApp) {
      if (typeof window.__jsqGetDatadogRumOpts__ === "undefined") return;
      const rumOpts = window.__jsqGetDatadogRumOpts__();

      jsqObservability.init({
        applicationId: rumOpts.applicationId,
        clientToken: rumOpts.clientToken,
        serviceName: "main/" + subApp,
        version: rumOpts.version,
        localDevInitOverride: rumOpts.initOverride === "True",
      });

      if (rumOpts.userId) {
        jsqObservability.setUser({ id: rumOpts.userId });
      }
      if (rumOpts.arenaId) {
        jsqObservability.setGlobalContextProperty("arenaId", rumOpts.arenaId);
      }
      if (rumOpts.arenaName) {
        jsqObservability.setGlobalContextProperty("arenaName", rumOpts.arenaName);
      }
    },
  };
  return datadogRum;
});

